module.exports = __webpack_public_path__ + "static/img/page25.3735a33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page25.jpg
// module id = /F1E
// module chunks = 0